import imagesCss from "../../../assets/styles/images/images.module.scss";
import { InfoOutlined } from "../../../assets/styles/images/icons";
import { Icon, Header } from "semantic-ui-react";

const ImagesUploadRequirements = () => (
    <div className={imagesCss.uploadRequirements}>
      <div className={imagesCss.requirementsHeader}>
        <InfoOutlined /> <Header as="h3">Upload Requirements</Header>
      </div>
      <div className={imagesCss.requirementsDescription}>
        <p>
          Before uploading, make sure your files meet the following requirements
          to ensure a smooth experience:
        </p>
      </div>
      <div className={imagesCss.requirementsList}>
        <div className={imagesCss.requirement}>
          <Icon name="check" />
          <span>The maximum file size is 5MB (5000KB) per image</span>
        </div>
        <div className={imagesCss.requirement}>
          <Icon name="check" />
          <span>
            All images should have the same width and height (e.g., 600x400px).
          </span>
        </div>
        <div className={imagesCss.requirement}>
          <Icon name="check" />
          <span>Keywords must exactly match your data sources.</span>
        </div>
        <div className={imagesCss.requirement}>
          <Icon name="check" />
          <span>
            Set the right dimensions for the HTML container in your email
            platform.
          </span>
        </div>
      </div>
    </div>
  );

export default ImagesUploadRequirements;
